import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyMapmenuMapsetMainCss = "mapy-mapmenu-mapset-main{display:flex;gap:8px;justify-content:flex-start;align-items:center;color:#011e39;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:24px}mapy-mapmenu-mapset-main mapy-mapmenu-mapset-preview{flex:0 0 auto;align-self:flex-start}";

const MapyMapmenuMapsetMain$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapmenuMapsetMain extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  static get style() { return mapyMapmenuMapsetMainCss; }
}, [4, "mapy-mapmenu-mapset-main"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-mapmenu-mapset-main"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-mapmenu-mapset-main":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapmenuMapsetMain$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapmenuMapsetMain = MapyMapmenuMapsetMain$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapmenuMapsetMain, defineCustomElement };

//# sourceMappingURL=mapy-mapmenu-mapset-main.js.map